import React from 'react';
import type { BrandConfig } from '@lds-efsp/brand-config';
import FormInput, { FormSelect } from '../../setup/components/FormInput';

export interface PartyData {
  name: string;
  capacity: string;
  registeredAgent?: string;
}

const CAPACITY_OPTIONS = [
  { value: '', label: 'Select capacity...' },
  { value: 'individual', label: 'Individual' },
  { value: 'corporation', label: 'Corporation' },
  { value: 'sole-proprietorship', label: 'Sole Proprietorship' },
  { value: 'association-or-partnership', label: 'Association or Partnership' },
  { value: 'trust', label: 'Trust' },
  { value: 'estate', label: 'Estate' },
  { value: 'minor', label: 'Minor' },
  { value: 'public-entity', label: 'Public Entity' },
  { value: 'fictitious', label: 'Fictitious' },
  { value: 'authorized-person', label: 'Authorized Person' },
  { value: 'defunct-corporation', label: 'Defunct Corporation' },
  { value: 'business-organization-form-unknown', label: 'Business (Form Unknown)' },
  { value: 'joint-stock-company-association', label: 'Joint Stock Company/Association' },
  { value: 'occupant-prejudgment-claim', label: 'Occupant (Prejudgment Claim)' },
];

interface PartyFieldsProps {
  brand: BrandConfig;
  index: number;
  value: PartyData;
  onChange: (party: PartyData) => void;
  onRemove: () => void;
  showRemove?: boolean;
}

const PartyFields: React.FC<PartyFieldsProps> = ({
  brand,
  index,
  value,
  onChange,
  onRemove,
  showRemove = true,
}) => {
  const update = (field: keyof PartyData, val: string) => {
    onChange({ ...value, [field]: val });
  };

  return (
    <div
      className="border rounded-lg p-4 mb-3"
      style={{ borderColor: brand.colors.border }}
    >
      <div className="flex justify-between items-center mb-2">
        <h4 className="text-sm font-medium" style={{ color: brand.colors.text }}>
          Party {index + 1}
        </h4>
        {showRemove && (
          <button
            onClick={onRemove}
            className="text-xs text-red-500 hover:text-red-700"
          >
            Remove
          </button>
        )}
      </div>

      <FormInput
        brand={brand}
        label="Name"
        name={`party-${index}-name`}
        value={value.name}
        onChange={(e) => update('name', e.target.value)}
        required
      />

      <FormSelect
        brand={brand}
        label="Capacity"
        name={`party-${index}-capacity`}
        value={value.capacity}
        onChange={(e) => update('capacity', e.target.value)}
        options={CAPACITY_OPTIONS}
        required
      />

      <FormInput
        brand={brand}
        label="Registered Agent"
        name={`party-${index}-registeredAgent`}
        value={value.registeredAgent ?? ''}
        onChange={(e) => update('registeredAgent', e.target.value)}
        helpText="If serving a corporation or LLC, enter the registered agent name"
      />
    </div>
  );
};

export default PartyFields;
export { CAPACITY_OPTIONS };
